import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { NeuralLoader } from "./neural-loader";
import { HeightTransition } from '@isyc-react/animation/modules/base/transition';
import { Slug } from '@isyc-react/animation/modules/base/trail';
import { useTranslation } from 'react-i18next';
import { nsmedia } from "../../../../i18n/namespaces";
import '@isyc-react/design/main';
const AwaitingVideoPermission = () => {
  const {
    t
  } = useTranslation(nsmedia.common);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-camera font-size-34 text-primary"
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-information-outline me-2 text-secondary"
  }), /*#__PURE__*/React.createElement("div", null, t('media.camera.permission.awaiting.video'))));
};
const AwaitingVideoAudioPermission = () => {
  const {
    t
  } = useTranslation(nsmedia.common);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-camera font-size-34 text-primary me-2"
  }), /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-microphone font-size-34 text-primary"
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-information-outline me-2 text-secondary"
  }), /*#__PURE__*/React.createElement("div", null, t('media.camera.permission.awaiting.videoAndAudio'))));
};
export const CameraLoad = props => {
  const {
    audio
  } = props;
  const [awaiting, setAwaiting] = React.useState(false);
  React.useEffect(() => {
    const timeoutId = setTimeout(() => setAwaiting(true), 2500);
    return () => clearTimeout(timeoutId);
  }, []);
  return /*#__PURE__*/React.createElement(Slug, {
    from: {
      opacity: 0,
      transform: 'translate3d(0,40px,0)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "media-camera-load p-4"
  }, /*#__PURE__*/React.createElement(HeightTransition, {
    show: awaiting
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-center flex-column pb-3"
  }, audio ? /*#__PURE__*/React.createElement(AwaitingVideoAudioPermission, null) : /*#__PURE__*/React.createElement(AwaitingVideoPermission, null))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-center"
  }, /*#__PURE__*/React.createElement(NeuralLoader, null))));
};